<template>
  <v-menu>
    <template #activator="{ on, attrs }">
      <v-btn icon class="mx-n4" v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list nav dense>
      <v-list-item-group>
        <div v-for="(action, index) in actions" :key="index">
          <v-tooltip bottom v-if="action.tooltip">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <ui-table-actions-item :action="action"></ui-table-actions-item>
              </div>
            </template>
            <span>{{ action.tooltip }}</span>
          </v-tooltip>

          <ui-table-actions-item
            v-if="!action.tooltip"
            :action="action"
            @click="onActionClick"
          ></ui-table-actions-item>
        </div>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    actions: { type: Array, required: true },
  },
  methods: {
    onActionClick(emit, action) {
      this.$emit(emit, action)
    },
  },
}
</script>
